import React from 'react';
import { withRouter } from 'react-router-dom';

import Navigation from '../Navigation';

const Footer = () => (
	<footer>
		<Navigation />
	</footer>
);

export default withRouter(Footer);